import React from 'react';
import classNames from 'classnames';
import { QualificationQuestionType } from 'models/DealRoom';
import RadioGroupField from 'components/RadioGroupField';
import { useForm } from 'react-final-form';

import './EnquiryQuestion.styles.scss';
import './EnquiryQuestion.styles.responsive.scss';

type EnquiryQuestionProps = {
  className?: string;
  name: string;
  question: QualificationQuestionType;
  show?: boolean;
};

const EnquiryQuestion: React.FC<EnquiryQuestionProps> = (props) => {
  const { className, name, question, show = true } = props;

  const { title, required, answers } = question;

  const classes = classNames('enquiry-question', { show: show }, className);

  const { change } = useForm();

  return (
    <div className={classes}>
      <p className="enquiry-title">{title}</p>

      <RadioGroupField
        name={`${name}.answer`}
        styled
        noValidate={!required}
        options={answers.map(({ answer }) => ({
          label: answer,
          value: answer,
        }))}
        customOnChange={(value) => {
          const { score } = answers.find(({ answer }) => answer === value);
          change(`${name}.score`, score);
        }}
      />
    </div>
  );
};

export default EnquiryQuestion;
